import { render, staticRenderFns } from "./offerSalaryModal.vue?vue&type=template&id=732b031a"
import script from "./offerSalaryModal.vue?vue&type=script&lang=js"
export * from "./offerSalaryModal.vue?vue&type=script&lang=js"
import style0 from "./offerSalaryModal.vue?vue&type=style&index=0&id=732b031a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports